import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../utils/app.settings';
import {
  IAgente,
  IAgentePost,
  IAgenteUpdate,
} from '../../interfaces/agents.interface';

@Injectable({
  providedIn: 'root',
})
export class AgentsService {
  constructor(
    private httpClient: HttpClient,
    private appSettings: AppSettings
  ) {}

  /**
   * Obtener todos los agentes
   */
  getAllAgents(): Observable<IAgente[]> {
    const url = this.appSettings.agents.urls.base;
    return this.httpClient.get<IAgente[]>(url);
  }

  /**
   * Obtener un agente por UUID
   */
  getAgentByUuid(uuid: string): Observable<IAgente> {
    const url = `${this.appSettings.agents.urls.base}/${uuid}`;
    return this.httpClient.get<IAgente>(url);
  }

  /**
   * Crear un nuevo agente
   */
  createAgent(data: IAgentePost): Observable<IAgente> {
    const url = this.appSettings.agents.urls.base;
    return this.httpClient.post<IAgente>(url, data);
  }

  /**
   * Actualizar un agente existente
   */
  updateAgent(uuid: string, data: IAgenteUpdate): Observable<IAgente> {
    const url = `${this.appSettings.agents.urls.base}/${uuid}`;
    return this.httpClient.put<IAgente>(url, data);
  }

  /**
   * Eliminar un agente
   */
  deleteAgent(uuid: string): Observable<void> {
    const url = `${this.appSettings.agents.urls.base}/${uuid}`;
    return this.httpClient.delete<void>(url);
  }
}
